/* Scroll functions */
(function($) {
    'use strict'

    document.querySelectorAll('.module-header .menu-main-container a').forEach((navigation_item) => {
        navigation_item.addEventListener('click', (ev) => {
            let anchor_elem = document.querySelector( navigation_item.getAttribute('href').replace('/', '') )


            if ( anchor_elem.offsetTop ) {
                ev.preventDefault()
                document.querySelector('body').classList.remove('is-open-menu')
    
                let header_height = document.querySelector('.module-header').clientHeight,
                    scroll_to =anchor_elem.offsetTop - header_height
    
                scrollTo(scroll_to, () => {
                    history.pushState({}, '', navigation_item.getAttribute('href'))
                })

                return false
            }
            
        })
    })

    /**
     * Native scrollTo with callback
     * @param offset - offset to scroll to
     * @param callback - callback function
     */
    function scrollTo(offset, callback) {
        const fixedOffset = offset.toFixed();
        const onScroll = function () {
                if (window.pageYOffset.toFixed() === fixedOffset) {
                    window.removeEventListener('scroll', onScroll)
                    callback()
                }
            }

        window.addEventListener('scroll', onScroll)
        onScroll()
        window.scrollTo({
            top: offset,
            behavior: 'smooth'
        })
    }
})(jQuery)